import { AsyncStorage } from "react-native";

const API_URL = "https://cita-previa.herokuapp.com/api/";
//const API_URL = "http://71870835a55f.ngrok.io/api/";

const makeRequest = async (path, method, body) => {
  const token = await AsyncStorage.getItem("x-citaprevia-token").catch(
    () => false
  );
  console.log(token);
  let auth = token ? { "x-citaprevia-tok": token } : {};
  try {
    let request;

    if (body)
      request = await fetch(API_URL + path, {
        method: method,
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          ...auth,
        },
      });
    else
      request = await fetch(API_URL + path, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          ...auth,
        },
      });
    let status = request.status;
    console.log(request);
    let originalResponse = request.headers["x-citaprevia-tok"];
    try {
      if (originalResponse) {
        await AsyncStorage.setItem("x-citaprevia-token", originalResponse);
      }
      request = await request.json();
    } catch (err) {
      request = {};
    }
    return [status, request];
  } catch (err) {
    return [500, { message: err.message }];
  }
};

export default makeRequest;
